import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const grey = ui.neutral[500];
const greyLight = ui.neutral[100];
const greyDark = ui.neutral[700];
const red = ui.red[600];
const white = ui.white[700];

export const dateRangeCss: CSSObject = {
  background: white,
  boxSizing: "border-box",
  borderRadius: "8px",
  display: "flex",
  height: "36px",
};

export const newDateRangeCss: CSSObject = {
  background: white,
  boxSizing: "border-box",
  borderRadius: "8px",
  display: "flex",
  height: "30px",
  marginTop: "4px",
  ...typographyStyles.fontFamily.circular,
};

export const dateCss: CSSObject = {
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.textXS,
  border: `1px solid ${greyLight}`,
  borderTopLeftRadius: "8px",
  borderBottomLeftRadius: "8px",
  color: red,
  padding: "4px 4px 4px 9px",
  width: "74px",
  display: "flex",
  textTransform: "uppercase",
  alignItems: "center",

  span: {
    ...typographyStyles.fontSize.textM,
    color: greyDark,
    fontWeight: "700",
    marginLeft: "8px",
  },
};

export const newDateCss: CSSObject = {
  ...typographyStyles.fontFamily.circular,
  borderLeft: `1px solid ${greyLight}`,
  borderTopRightRadius: "8px",
  borderBottomRightRadius: "8px",
  color: greyDark,
  display: "flex",
  alignItems: "center",
  fontSize: "14px",
  paddingLeft: "0.5rem",
  paddingRight: "10px",

  span: {
    marginLeft: "4px",
  },
};

export const countdownCss: CSSObject = {
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.textS,
  border: `1px solid ${greyLight}`,
  borderLeft: "hidden",
  borderTopRightRadius: "8px",
  borderBottomRightRadius: "8px",
  color: grey,
  fontWeight: "400",
  padding: "4px 8px 4px 6px",
  display: "flex",
  alignItems: "center",
};

export const newCountdownCss: CSSObject = {
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.textS,
  borderRight: "hidden",
  borderTopLeftRadius: "8px",
  borderBottomLeftRadius: "8px",
  color: greyDark,
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  paddingInline: "8px",
  minWidth: "123px",
  textWrap: "nowrap",
};
